import axios from 'axios';
import {global} from "./util";

export const api = global('api', createApi());

function createApi() {
    const api = axios.create({
        baseURL: '/api/cursus',
        headers: {
            'X-Sola-Id': document.head.querySelector('meta[name="sola-id"]')?.content ?? '',
        },
    });
    api.interceptors.response.use(null, error => {
        if(error.response?.status === 419) {
            alert('Votre session a expiré, cliquez sur Ok pour recharger la page');
            location.reload();
        }
        return Promise.reject(error);
    });
    return api;
}

export function setDomainUrl(domain) {
    api.defaults.baseURL = `${domain}${api.defaults.baseURL}`;
}

export function handleUnauthenticated(error) {
    if(error.response?.status === 401) {
        alert(`Vous n'êtes plus connecté, cliquez sur Ok pour recharger la page`);
        location.reload();
    }
    return Promise.reject(error);
}

export function getCourses({ category, page, per_page, year, formations }) {
    return api.get('/courses', {
        params: {
            category,
            page,
            per_page,
            year,
            formations
        }
    }).then(response => response.data);
}

export function getCriterias() {
    return api.get('/criterias').then(response => response.data.data);
}

export function getCourse({ courseId, thumbnail_width }) {
    return api.get(`/courses/${courseId}`, {
        params: {
            thumbnail_width,
        }
    })
    .then(response => response.data.data);
}

export function getSessionRegister({ courseId, sessionId, orderId }) {
    return api.get(`/courses/${courseId}/sessions/${sessionId}/register/${orderId ?? ''}`)
        .then(response => response.data.data);
}

export function getOrder({ courseId, sessionId, orderId, withTotal }) {
    return api.get(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}`,{
        params: {
            total: withTotal ? 1 : undefined
        },
    })
    .then(response => response.data.data);
}

export function postOrderAccountType({ courseId, sessionId, orderId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders${orderId ? `/${orderId}` : ''}/account_type`, data)
        .then(response => response.data.data);
}

export function postOrderAccount({ courseId, sessionId, orderId,  data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/account`, data)
        .then(response => response.data.data);
}

export function postOrderRegistrant({ courseId, sessionId, orderId, registrantId=null, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/registrants/${registrantId ?? ''}`, data)
        .then(response => response.data.data);
}

export function deleteOrderRegistrant({ courseId, sessionId, orderId, registrantId }) {
    return api.delete(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/registrants/${registrantId}`)
        .then(response => response.data.data);
}

export function postOrderThirdParties({ courseId, sessionId, orderId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/thirdParties`, data)
        .then(response => response.data.data);
}

export function postOrderOptions({ courseId, sessionId, orderId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/options`, data)
        .then(response => response.data.data);
}

export function postOrderForm({ courseId, sessionId, orderId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/formoj`, data)
        .then(response => response.data.data);
}

export function postOrderFormRegistrant({ courseId, sessionId, orderId, registrantId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/formoj/${registrantId}`, data)
        .then(response => response.data.data);
}

export function postOrderConfirmationForm({ courseId, sessionId, orderId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/form-confirmation`, data)
        .then(response => response.data.data);
}

export function postOrderPrices({ courseId, sessionId, orderId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/prices`, data)
        .then(response => response.data.data);
}

export function postOrderMeals({ courseId, sessionId, orderId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/meals`, data)
        .then(response => response.data.data);
}

export function postOrderPayment({ courseId, sessionId, orderId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/payment`, data)
        .then(response => response.data.data);
}

export function postOrderUploadUrl({ courseId, sessionId, orderId }) {
    return `${api.defaults.baseURL}/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/upload`;
}

export function postOrderConfirm({ courseId, sessionId, orderId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/confirm`, data)
        .then(response => response.data.data);
}

export function postOrderQuote({ courseId, sessionId, orderId, data }) {
    return api.post(`/courses/${courseId}/sessions/${sessionId}/orders/${orderId}/quote`, data)
        .then(response => response.data.data);
}

export function getAccounts() {
    return api.get('/accounts')
        .then(response => response.data.data);
}

export function getAccount({ accountId }) {
    return api.get(`/accounts/${accountId}`)
        .then(response => response.data.data);
}

export function postAccount({ accountId, data }) {
    return api.post(`/accounts/${accountId ?? ''}`, data)
        .then(response => response.data.data);
}

export function getFooterItems() {
    return api.get('/footer')
        .then(response => response.data.data);
}
